module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid4.3fde160d.png";